export enum OfferStyle {
  DEFAULT = 'default',
  VERTICAL = 'vertical'
}
